export const styles = theme => ({
    showDialog: {
        display: 'block',
    },
    hiddenDialog: {
        display: 'none',
    },
    wrapDialog: {
        minWidth: '40%'
    },
    content: {
        color: '#263238',
        fontSize: '14px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        // fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '-0.05px',
    },
    title: {
        color: '#263238',
        fontWeight: '500',
        fontSize: '16px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        lineHeight: '21px',
        letterSpacing: '-0.05px',
    },
    containerContent: {
        padding: '16px 4px'
    },
    containerAction: {
        padding: '16px 24px'
    }
});